import React, { useEffect, useRef, useState } from 'react'
import GolfCourseIcon from 'components/material-symbol/icons/GolfCourse'
import GpsFixedOutlinedIcon from 'components/material-symbol/icons/GpsFixed'
import AccountTreeOutlinedIcon from 'components/material-symbol/icons/AccountTree'
import ThumbUpAltOutlinedIcon from 'components/material-symbol/icons/ThumbUpAlt'
import ThumbDownAltOutlinedIcon from 'components/material-symbol/icons/ThumbDownAlt'
import WorkspacePremiumOutlinedIcon from 'components/material-symbol/icons/WorkspacePremium'
import {
  FrontHandOutlinedIcon,
  PrivateSessionIcon,
} from 'components/icons/refreshed-icons'
import { DetailSection, DetailField } from './content-box'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'
import { gtmEvent } from 'lib/gtm'
import { useIntersectionObserver } from 'lib/utils'

export default function GolferInformation({ golferProfile }) {
  const ref = useRef()
  const location = useLocation()
  const [hasFiredEvent, setHasFiredEvent] = useState(false)
  const { event } = qs.parse(location.search)
  const isIntersecting = useIntersectionObserver(ref, {
    root: null,
    rootMargin: '0px',
    threshold: 1.0,
  })

  useEffect(() => {
    if (isIntersecting && !hasFiredEvent && !event) {
      gtmEvent({
        event: 'click-navigation',
        formCategory: 'golfer-intake-form',
        formAction: 'golfer-profile-completion-view',
      })
      setHasFiredEvent(true)
    }
  }, [isIntersecting, hasFiredEvent, event])

  if (!golferProfile) return null

  const {
    frequencyOfPlay,
    homeGolfCourse,
    golfJourney,
    hasOwnClubs,
    handedness,
    handicap,
    confidentArea,
    improvementArea,
  } = golferProfile

  const clubsValue =
    hasOwnClubs == null
      ? null
      : hasOwnClubs
        ? 'Bringing own clubs'
        : 'Needs rental clubs'

  const handicapValue =
    handicap == null ? null : handicap === '' ? 'Not sure' : handicap

  const items = [
    {
      key: 'frequency',
      icon: GpsFixedOutlinedIcon,
      label: 'Frequency of Play',
      value: frequencyOfPlay,
    },
    {
      key: 'journey',
      icon: AccountTreeOutlinedIcon,
      label: 'Golfer Journey',
      value: golfJourney,
    },
    {
      key: 'confidence',
      icon: ThumbUpAltOutlinedIcon,
      label: 'Area of Confidence',
      value: confidentArea,
    },
    {
      key: 'improvement',
      icon: ThumbDownAltOutlinedIcon,
      label: 'Area of Improvement',
      value: improvementArea,
    },
    {
      key: 'handedness',
      icon: FrontHandOutlinedIcon,
      label: 'Handedness',
      value: handedness,
      useRefreshedIcon: true,
    },
    {
      key: 'handicap',
      icon: WorkspacePremiumOutlinedIcon,
      label: 'Handicap',
      value: handicapValue,
    },
    {
      key: 'clubs',
      icon: PrivateSessionIcon,
      label: 'Clubs',
      value: clubsValue,
      useRefreshedIcon: true,
    },
    {
      key: 'home-course',
      icon: GolfCourseIcon,
      label: 'Home Course',
      value: homeGolfCourse,
    },
  ]

  const visibleItems = items.filter(
    item => item.value != null && item.value !== '',
  )

  if (visibleItems.length === 0) return null

  return (
    <DetailSection title="Golfer information" innerRef={ref}>
      {visibleItems.map(item => (
        <DetailField
          key={item.key}
          icon={item.icon}
          label={item.label}
          value={item.value}
          useRefreshedIcon={item.useRefreshedIcon}
        />
      ))}
    </DetailSection>
  )
}
